export const eventColors = {
	not_confirmed: '#68cae0',
	confirmed: '#06a6c9',
	came: '#f3a50a',
	completed: '#28db74',
	canceled: '#999999',
	not_appeared: '#eb774a',
};



// WEBPACK FOOTER //
// ./src/common/constants.js